import variables from "../variables.scss";
export { default as colorVariables } from "../variables.scss";
export const loadingColor = variables.color2;
export const pageloadingSize = 150;
export const appLoadingSize = 80;
export const twitterLink = "https://twitter.com/heyitsanmolj";
export const githubLink = "https://github.com/anmoljhamb";
export const instagramLink = "https://instagram.com/heyitsanmolj";
export const linkedInLink = "https://www.linkedin.com/in/anmoljhamb";
